/**
 * Extracts <summary> tags from agent responses and returns cleaned message
 */

export interface ExtractionResult {
  cleanedMessage: string;
  summaries: string[];
}

/**
 * Extracts all <summary>...</summary> tags from a message
 * Returns the message with summary tags removed, plus array of extracted summaries
 */
export function extractSummaries(message: string): ExtractionResult {
  const summaryRegex = /<summary>([\s\S]*?)<\/summary>/gi;
  const summaries: string[] = [];

  // Extract all summaries
  let match;
  while ((match = summaryRegex.exec(message)) !== null) {
    summaries.push(match[1].trim());
  }

  // Remove summary tags from message
  const cleanedMessage = message.replace(summaryRegex, '').trim();

  return {
    cleanedMessage,
    summaries,
  };
}

/**
 * Checks if a message contains a reflection completion signal
 */
export function hasReflectionComplete(message: string): boolean {
  return /<reflection_complete\s*\/?>/i.test(message);
}

/**
 * Removes reflection completion tags from message
 */
export function removeReflectionCompleteTags(message: string): string {
  return message.replace(/<reflection_complete\s*\/?>/gi, '').trim();
}
